import { extendTheme } from '@chakra-ui/react';

export const colors = {
  keyops: {
    teal: '#39BDAF',
    alpha20teal: '#39BDAF33',
    blue: '#3376D1',
    lighterBlue: '#F5FBFF',
    darkerBlue: '#2c5282',
    darkerBlue90: '#2c5282e6',
    gray: '#B3B3B3',
    gray50: '#F7FAFC',
    gray500: '#718096',
    visualizationBlue: '#7FB5E9',
    arcticBlue: '#E0F0FF',
    midnightBlue: '#1A4B7B',
    orange: '#FAAA3C',
    lighterOrange: '#FDF5E5',
    purple: '#302B70',
    whiteSmoke: '#F5F5F5',
  },
  filterDropdown: {
    500: '#4A5568',
  },
  selectedFiltersPillBorder: {
    500: '',
  },
};

const fonts = {
  heading: `'Inter', sans-serif`,
  body: `Inter, sans-serif`,
};

const customTheme = extendTheme({ colors, fonts });

export default customTheme;
